// Browser localStorage is a weaker secret store than expo-secure-store — accepted
// for v1 per the handoff's "Risks and edge cases" (single trusted PC).
//
// Revision 4: no more keypair/wrapped key — `chatKey` is derived locally from
// the password and stored here alongside the device token, same as before.

export interface Session {
  username: string;
  deviceId: string;
  token: string;
  chatKey: string; // base64, derived via scrypt, never sent to the server
}

const KEY = "bridge.session.v1";

export function loadSession(): Session | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Session;
  } catch {
    return null;
  }
}

export function saveSession(session: Session): void {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
}
